


































































import Vue from 'vue'
import {mapState} from 'vuex'
import * as types from '../store/types'
import * as actions from '../store/actions'
import * as fields from '../store/fields'

// const catchmentKeyToLabel = (key: string) => {
//   const map = {'chd__05'  : 'Children under 5',
//     'chl__01'  : 'Children under 1',
//     'lv_brth'  : 'Live Births',
//     'ttl_ppl' : 'Total Population',
//     'wmn_chl' : 'Woman of Childbearing Age'}
//   return map[key] ?? key
// }

export default Vue.extend({
  name: 'CatchmentTable',
  data() {
    return {
      headers: fields.catchmentHeaders,
      items: fields.exampleCatchmentItems,
      supplyHeaders: fields.exampleCatchmentSupplyHeaders,
      supplyItems: fields.exampleCatchmentSupplyItems,
      totalCost: 1000,
      totalCubicCm: 400000,
      panels: ['people', 'supplies']
    };
  },

  computed: mapState({
    sources: (state: any) => (state.map.sources as Array<types.Schema$MapboxSource>),
    layers: (state: any) => (state.map.layers as Array<any>)
  })

}) as any;
